export const FIELD_TYPES = {
  VALUE: "value",
  CURRENCY: "currency",
  DATE: "date",
  TIME: "time",
  DATETIME: "datetime",
  TOGGLE: "toggle",
  DROPDOWN: "dropdown",
  DROPDOWN_ASYNC: "dropdownAsync",
  US_PHONE: "usPhone",
  EVENT_DAYS: "eventDays",
  FILE: "file",
  CATALOG: "catalog",
  PHOTO: "photo",
  USER: "user",
  RADIO_LIST: "radioList",
  TOGGLE_OPTION: "toggleOption",
  COLOR_PICKER: "colorPicker",
  ICON_PICKER: "iconPicker",
  CHECKBOX: "checkbox",
  LOOKUP: "lookup",
  IMAGE: "image",
  COLOR: "color",
  VIDEO: "videoUploader",
  MARK_EVENT_DAYS: "eventGroupDays"
};

export const FORM_ACTIONS = {
  UPLOAD_PHOTO: "uploadPhoto",
  TAKE_PHOTO: "takePhoto",
  EDIT_PHOTO: "editPhoto",
  REMOVE_PHOTO: "removePhoto",
  INIT_VIDEO_UPLOADER: "initVideo",
  UPLOAD_VIDEO: "uploadVideo",
  CANCEL_VIDEO: "cancelUpload"
};

export const DEFAULT_DATE_FORMAT = "L";
export const DATE_FORMAT_MATERIAL = "MM/DD/YYYY @ hh:mm a";

export const DEFAULT_PRESET_SKETCH_COLORS = [
  "#F08C00",
  "#FCC419",
  "#FFE066",
  "#E8590C",
  "#FF922B",
  "#FFC078",
  "#E03131",
  "#FF6B6B",
  "#FFA8A8",
  "#2F9E44",
  "#51CF66",
  "#8CE99A",
  "#1B6EC2",
  "#329AF0",
  "#72C3FC",
  "#1E62D8",
  "#5C7CFA",
  "#91A7FF",
  "#343434",
  "#ADADAD",
  "#DEDEDE"
];

export const TINY_MCE_EXTERNAL_PLUGINS = {
  eqneditor: "https://static.sessionboard.com/js/eqneditor.js"
};
